import {
  CommonModule,
  ModuleWithData,
  ModuleError,
  PaginationModule,
} from '@/models/store'

import { EvTrip } from '@/models/evTrip'
import { EvTripLog } from '@/models/evTripLog'

import {
  getInitialCommonModuleState,
  getInitialDataModuleState,
  getPagintaionModuleState,
} from '@/helpers/store-state'

export type EvTripDetailsModule = ModuleWithData<EvTrip>
export type EvTripLogsModule = ModuleWithData<EvTripLog[]>

export interface State {
  listModule: PaginationModule<EvTrip>

  // Trip details grouped by trip id
  tripsDetails: Record<string, EvTripDetailsModule | undefined>

  // Trip logs grouped by trip id
  tripsLogs: Record<string, EvTripLogsModule | undefined>
}

export const getInitialEvTripDetailsState = (): EvTripDetailsModule => ({
  ...getInitialDataModuleState(),
})

export const getInitialEvTripLogsModuleState = (): EvTripLogsModule => ({
  ...getInitialDataModuleState(),
})

export const getInitialEvTripsState = (): State => ({
  listModule: getPagintaionModuleState(),
  tripsDetails: {},
  tripsLogs: {},
})
